<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("tiertypes") }}</div>
        <div class="section-subTitle my-2">
          Manage All your Tier Types here.
        </div>
      </div>
      <div>
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <!-- v-if="cinema_manager_add_edit_disabled != 3" -->
        <b-button
          variant="default"
          :to="{ name: 'Add Tier Types' }"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-end mb-3">
      <!-- <FilterByStatusDropdown /> -->
    </div>

    <!-- <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
            >{{list.name}}</b-dropdown-item>
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active':''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active':''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>-->

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container">
      <div class="desg-list-header" style="justify-content:normal">
        <div class="pr-4">{{ $tc("status", 2) }}</div>

        <div>Cinema Types</div>
      </div>
      <ul class="desg-list">
        <li
          v-for="(tier_type, tierTypeKey) in tier_type_list"
          :key="tierTypeKey"
          class="light_grey_back"
          style="justify-content:normal"
        >
          <div class="d-flex align-items-center">
            <!-- <label class="ios-switch">
              <input
                v-model="tier_type.tier_type_is_active"
                true-value="Y"
                false-value="N"
                disabled
                type="checkbox"
                class="ios-checkbox"
              />
              <span class="switch-slider"></span>
            </label> -->
            <StatusDot
              :status="
                tier_type.tier_type_is_active === 'Y'
                  ? 'active'
                  : tier_type.tier_type_is_active === 'N' && 'inactive'
              "
            />
            <b-dropdown right variant="edit" class="ml-2">
              <b-dropdown-item
                :to="{
                  name: 'Edit Tier Types',
                  params: { tier_type_id: tier_type.tier_type_id }
                }"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t("edit") }}
              </b-dropdown-item>
              <b-dropdown-item
                :to="{
                  name: 'View Tier Types',
                  params: { tier_type_id: tier_type.tier_type_id }
                }"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t("view") }}
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="ml-4">{{ tier_type.tier_type_name }}</div>
        </li>
      </ul>
      <!-- <table>
        <tbody>
          <tr>
            <td colspan="2">
              <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div>
            </td>
          </tr>
        </tbody>
      </table>-->
    </div>
    <br />
    <!-- <b-pagination
      v-model="currentPage"
      total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>-->
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import moment from "moment";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown
  },
  data() {
    return {
      tier_type_list: []
    };
  },
  mounted() {
    this.getTierTypeList();
  },
  methods: {
    getTierTypeList: function() {
      MasterService.GetTierTypeList()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.tier_type_list = data.Records;
          } else {
            this.tier_type_list = [];
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TierTypeComponents/tierTypes.vue